import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import HeadingStyles from '@stories/Components/Global/Typography/Heading.styles';
import ImageWithCredit from '@stories/Components/ImageWithCredit/ImageWithCredit';
import ImageWithCreditStyles from '@stories/Components/ImageWithCredit/ImageWithCredit.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
import RichTextStyles from '../RichText/RichText.styles';
const Container = styled(SectionWrapper) `
  ${setCssVar('accentColor', brand.htaRebrand.green)};
  ${setCssVar('bgColor', brand.htaRebrand.greenBg)};
  ${setCssVar('fgColor', brand.black)};

  display: flex;
  background: ${cssVar('bgColor')};
  min-height: 300px;
  padding: 32px 0;
  position: relative;
  margin-bottom: 100px;

  .theme-apl & {
    ${setCssVar('accentColor', brand.black)};
    ${setCssVar('bgColor', brand.apl.greenLight)};
    ${setCssVar('fgColor', brand.black)};
  }

  .theme-hh & {
    ${setCssVar('accentColor', brand.black)};
    ${setCssVar('bgColor', brand.hortHouse.green)};
    ${setCssVar('fgColor', brand.black)};
  }

  &[data-image='true'] {
    @media ${until(Device.TabletLarge)} {
      padding: 32px 0 60px;
    }

    @media ${until(Device.Tablet)} {
      padding: 32px 0;
    }
  }

  &[data-image='false'] {
    overflow: hidden;
    @media ${from(Device.Desktop)} {
      min-height: 500px;
    }
  }
`;
const Inner = styled.div `
  position: relative;
  height: 100%;
  justify-content: center;

  display: grid;
  gap: 30px;
  grid-template-columns: repeat(12, 1fr);
  z-index: 1;

  @media ${until(Device.Tablet)} {
    gap: 12px;
  }
`;
const BreadcrumbWrapper = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  color: ${brand.grey};
  transform: translateY(-10px);
`;
const ContentWrapper = styled.div `
  padding: 32px 0;

  [data-image='false'] & {
    @media ${until(Device.Tablet)} {
      grid-column: 1 / span 12;
    }

    @media ${from(Device.Tablet)} {
      grid-column: 3 / span 8;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: 1 / span 6;
    }
  }

  [data-image='true'] & {
    @media ${until(Device.Tablet)} {
      grid-column: 1 / span 12;
    }

    @media ${from(Device.Tablet)} {
      grid-column: 3 / span 8;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: 1 / span 5;
    }
  }
`;
const PreTitle = styled.span `
  ${fonts.sourceSansPro.regular};
  color: ${cssVar('accentColor')};
  text-transform: uppercase;
  font-size: 16px;
  line-height: 32px;
  letter-spacing: 0.02em;
`;
const Title = styled.h1 `
  ${HeadingStyles.H4Styles};

  @media ${until(Device.Tablet)} {
    font-size: 26px;
    line-height: 36px;
  }
`;
const Author = styled.p `
  ${fonts.sourceSansPro.regular};
  font-size: 22px;
  line-height: 34px;
`;
const Content = styled.div `
  ${RichTextStyles.contentStyles};

  [data-image='true'] & {
    max-width: 611px;
  }

  [data-image='false'] & {
    max-width: 804px;
  }
`;
const ImageWrapper = styled.div `
  position: relative;
  align-self: flex-start;

  @media ${until(Device.Tablet)} {
    grid-column: 1 / span 12;
    margin-left: -18px;
    margin-right: -18px;
  }

  @media ${from(Device.Tablet)} {
    grid-column: 3 / span 8;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: 6 / span 7;
  }

  ${ImageWithCreditStyles.Container} {
    height: auto;
    top: -32px;
    margin-bottom: -140px;
    padding-bottom: 60%;

    @media ${from(Device.Tablet)} {

      margin-bottom: -120px;
    }
  }

  ${ImageWithCreditStyles.Image} {
    border-radius: 0 0 24px 24px;
  }

  ${ImageWithCreditStyles.ImageCredit} {
    right: 24px;

    @media ${until(Device.TabletLarge)} {
      font-size: 14px;
    }
  }
`;
const Image = styled(ImageWithCredit) ``;
const LogoIcon = styled.img `
  position: absolute;
  bottom: -50px;
  right: -50px;
  color: ${brand.white};
  opacity: 0.2;
  width: 291px;
  transform: rotate(-25deg);

  .theme-hh & {
    transform: rotate(0);
    bottom: 0;
  }

  @media ${from(Device.TabletLarge)} {
    width: 400px;
  }

  @media ${from(Device.Desktop)} {
    width: 566px;
    right: 30px;
  }
`;
export default {
    Author,
    BreadcrumbWrapper,
    Container,
    Content,
    ContentWrapper,
    Image,
    ImageWrapper,
    Inner,
    LogoIcon,
    PreTitle,
    Title,
};
